import type { StripeCharge } from '@/types/clinicalAdmin';

export type ChargeBadgePresentation = {
  tone: 'good' | 'danger' | 'neutral';
  label: string;
};

/** A later dispute is more authoritative than the original paid capture. */
export function chargeBadgePresentation(
  charge: Pick<StripeCharge, 'paid' | 'status' | 'disputed' | 'dispute_status'>,
): ChargeBadgePresentation {
  if (charge.disputed) {
    switch (charge.dispute_status) {
      case 'needs_response':
        return { tone: 'danger', label: 'Dispute · needs response' };
      case 'under_review':
        return { tone: 'danger', label: 'Dispute · under review' };
      case 'lost':
        return { tone: 'danger', label: 'Dispute lost' };
      case 'warning_needs_response':
        return { tone: 'danger', label: 'Dispute warning · needs response' };
      case 'warning_under_review':
        return { tone: 'danger', label: 'Dispute warning · under review' };
      case 'won':
        return { tone: 'good', label: 'Dispute won' };
      case 'warning_closed':
        return { tone: 'good', label: 'Dispute warning closed' };
      case 'prevented':
        return { tone: 'good', label: 'Dispute prevented' };
      default:
        // Stripe may add a lifecycle value before this portal deploys. Do not
        // mislabel an unknown state as either an active loss or a resolution.
        return { tone: 'neutral', label: 'Dispute · status unavailable' };
    }
  }
  return {
    tone: charge.paid ? 'good' : 'danger',
    label: charge.status || '—',
  };
}
